import { render, staticRenderFns } from "./NewProjectTable.vue?vue&type=template&id=47fb924e&scoped=true&"
import script from "./NewProjectTable.vue?vue&type=script&lang=js&"
export * from "./NewProjectTable.vue?vue&type=script&lang=js&"
import style0 from "./NewProjectTable.vue?vue&type=style&index=0&id=47fb924e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fb924e",
  null
  
)

export default component.exports